import {put,takeLatest,call} from 'redux-saga/effects';
import * as authService from '../../../services/authService'

import {
  REGISTER_GOOGLE,
  REGISTER_GOOGLE_SUCCESS,
  REGISTER_GOOGLE_ERROR
}
  from "../../actions/auth";

function* registerGoogleSaga(action) {
  try {
    const data=yield call(authService.RegisterGoogle,action.payload)
    yield put({
      type: REGISTER_GOOGLE_SUCCESS,
      payload: {userData: data}
    });


  } catch(error) {
    yield put({type: REGISTER_GOOGLE_ERROR,error: error.data});
  }
}


export function* registerGoogleWatcher() {
  yield takeLatest(REGISTER_GOOGLE,registerGoogleSaga);
}